export default __webpack_public_path__ + "static/media/7-cn.bbc71d9d.webp";